import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import axios from "axios";
import 'react-toastify/dist/ReactToastify.css';
import { checkinOptionList, hasPaidOptionList, paymentMethodOptionList } from "../../refs/lists";
import './Modal.css';

const EditBoatModal = (props) => {

  const [boatName, setBoatName] = useState();
  const [hasCheckedIn, setHasCheckedIn] = useState();
  const [hasPaid, setHasPaid] = useState();
  const [amountPaid, setAmountPaid] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState();
  const [numWristbands, setNumWristbands] = useState();
  const [dateRegistered, setDateRegistered] = useState();
  const [teamEmail, setTeamEmail] = useState();
  const [teamPhoneNumber, setTeamPhoneNumber] = useState();
  const [boatMake, setBoatMake] = useState();
  const [boatLength, setBoatLength] = useState();
  const [boatList, setBoatList] = useState([]);

  const delayRefresh = () => {
    setTimeout(() => {
      window.location.reload(false);
    }, 2000);
  }

  const validateAndSubmitUserInput = () => {

    // Update boat record
    let boatOptions = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/updateBoat',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        id: props.selectedRow[0].id,
        boatName: boatName,
        hasCheckedIn: hasCheckedIn,
        hasPaid: hasPaid,
        amountPaid: amountPaid,
        paymentMethod: paymentMethod,
        numWristbands: numWristbands,
        dateRegistered: dateRegistered,
        teamEmail: teamEmail,
        teamPhoneNumber: teamPhoneNumber,
        boatMake: boatMake,
        boatLength: boatLength,
      })
    }
    const updateBoat = async () =>{
      let response = await axios(boatOptions);
      toast.success("Successfully updated boat status. Please wait while table refreshes.")
    }
    updateBoat();
    delayRefresh();
  }

  const phoneFormat = (userInput) => {
    var input = userInput.replace(/\D/g,'').substring(0,10); //Strip everything but 1st 10 digits
    var size = input.length;
    if (size>0) {input="("+input}
    if (size>3) {input=input.slice(0,4)+") "+input.slice(4)}
    if (size>6) {input=input.slice(0,9)+"-" +input.slice(9)}
    return input;
  }

  useEffect(() => {
    // Get boat list
    const fetchRegisteredBoatsFromDatabase = async () => {
      let params = {
        method: 'GET',
        url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getAllBoats',
        headers: {'Content-Type': 'application/json'},
      }
      let response = await axios(params);
      let responseList = []
      if (response.data) {
        response.data.forEach((entry) => {
          responseList.push(entry)
        })
      }
      setBoatList(responseList);
    }
    fetchRegisteredBoatsFromDatabase();

    const boatToBeEdited = props.selectedRow[0];
    setBoatName(boatToBeEdited['boatName']);
    setHasCheckedIn(boatToBeEdited['hasCheckedIn']);
    setHasPaid(boatToBeEdited['hasPaid']);
    setAmountPaid(boatToBeEdited['amountPaid']);
    setPaymentMethod(boatToBeEdited['paymentMethod']);
    setNumWristbands(boatToBeEdited['numWristbands']);
    setDateRegistered(boatToBeEdited['dateRegistered']);
    setTeamEmail(boatToBeEdited['teamEmail']);
    setTeamPhoneNumber(boatToBeEdited['teamPhoneNumber']);
    setBoatMake(boatToBeEdited['boatMake']);
    setBoatLength(boatToBeEdited['boatLength']);
  }, []);

  return (
    <>
      <div className="modal">
        <div onClick={props.toggleModal} className="overlay"></div>
        <div className="modal-content">
          <h2>Edit Boat Entry</h2>
          <label>*Boat: <strong>{boatName}</strong></label>
          <br/>
          <br/>
          <label>Has Checked In: </label>
          <select value={hasCheckedIn} onChange={(e) => setHasCheckedIn(e.target.value)}>
            {checkinOptionList.map((checkinOption, i) => {
              if (checkinOption == hasCheckedIn) {
                return <option key={i} value={checkinOption} selected="selected">{checkinOption}</option>
              } else {
                return <option key={i} value={checkinOption} >{checkinOption}</option>
              }
            })}
          </select>
          <label>Has Paid: </label>
          <select value={hasPaid} onChange={(e) => setHasPaid(e.target.value)}>
            {hasPaidOptionList.map((hasPaidOption, i) => {
              if (hasPaidOption == hasPaid) {
                return <option key={i} value={hasPaidOption} selected="selected">{hasPaidOption}</option>
              } else {
                return <option key={i} value={hasPaidOption} >{hasPaidOption}</option>
              }
            })}
          </select>
          <br/>
          <br/>
          { hasPaid == "Yes" ? (
            <>
              <label>Payment Method: </label>
              <select value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
                {paymentMethodOptionList.map((paymentMethodOption, i) => {
                  if (paymentMethodOption == paymentMethod) {
                    return <option key={i} value={paymentMethodOption} selected="selected">{paymentMethodOption}</option>
                  } else {
                    return <option key={i} value={paymentMethodOption} >{paymentMethodOption}</option>
                  }
                })}
              </select>
              <label>Amount Paid ($USD):</label>
              <input 
                type="number" 
                value={amountPaid}
                id='amountPaid'
                onChange={(e) => setAmountPaid(e.target.value)}
                required
                min="0.01"
                max="999999.99"
                step="0.01"
              />
              <br/>
              <br/>
            </>
          ) : (
            <></>
          )}
          <label>Number of Wristbands:</label>
          <input 
            type="number" 
            value={numWristbands}
            id='numWristbands'
            onChange={(e) => setNumWristbands(e.target.value)}
            required
            min="6"
            max="18"
            step="1"
          />
          <br/>
          <br/>
          <label>Date Registered:</label>
          <input 
            type="date" 
            value={dateRegistered}
            id='dateRegistered'
            onChange={(e) => setDateRegistered(e.target.value)}
          />
          <br/>
          <br/>
          <label>Team Email: </label><input required type="email" value={teamEmail} onChange={(e) => setTeamEmail(e.target.value)}></input>
          <label>Team Phone Number: </label><input required type="tel" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" value={teamPhoneNumber} onChange={(e) => setTeamPhoneNumber(phoneFormat(e.target.value))}></input><br/><br/>
          <label>Boat Make: </label><input type="text" value={boatMake} onChange={(e) => setBoatMake(e.target.value)} ></input>
          <label>Boat Length (ft): </label><input type="number" min="1" step="1" value={boatLength} onChange={(e) => setBoatLength(e.target.value)} ></input><br/><br/>
          <button className="btn-modal" onClick={validateAndSubmitUserInput} type="button">Submit</button>
          <button className="close-modal" onClick={props.toggleModal}>CLOSE</button>
        </div>
      </div>  
    </>
  );
}

export default EditBoatModal;

